var map = {
	"./tech-radar-august-2019": [
		215,
		4
	],
	"./tech-radar-august-2019.json": [
		215,
		4
	],
	"./tech-radar-november-2023": [
		216,
		5
	],
	"./tech-radar-november-2023.json": [
		216,
		5
	],
	"./tech-radar-october-2020": [
		217,
		6
	],
	"./tech-radar-october-2020.json": [
		217,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 329;
module.exports = webpackAsyncContext;